import type { ReactNode } from 'react';

import { BreakpointContext } from './breakpoint-context';
import { useElementBreakpoint } from './useBreakpoint';

/**
 * Meet zijn eigen container en deelt het niveau met de hele boom. Zet hem om de
 * inhoud die je wilt meten - meestal één keer, in de layout.
 */
export function BreakpointProvider({ children }: { children: ReactNode }) {
    const { ref, state } = useElementBreakpoint<HTMLDivElement>();

    return (
        <div ref={ref} className="sk-breakpoint-root" data-breakpoint={state.level}>
            <BreakpointContext.Provider value={state}>{children}</BreakpointContext.Provider>
        </div>
    );
}
